import React, { useContext, useEffect, useMemo, useState } from "react";
import EditProfile from "./EditProfile";
import Payment from "./Billing/index.jsx";
import backgroundImage from "../../../assets/profile/background.png";
import Password from "./Password";
import useUsers from "../../../hooks/useUsers";
import { PAGE_STATE } from "../../../constants";
import ProfileContext from "../ProfileContext";
import AppContext from "../../../AppContext";
import { langComponent } from "../../../constants";
import ContentLoader from "react-content-loader";
import { toast } from "react-toastify";
import Button from "../../common/Button/index.jsx";
import UploadModal from "./UploadModal.jsx";
import EditCompany from "./EditCompany.jsx";
import useCompanies from "../../../hooks/useCompanies.js";

const assetsUri = import.meta.env.ASSETS_URI;

const Edit = () => {
  const { user, company, isCompany } = useContext(ProfileContext);
  const { getLang } = useContext(AppContext);
  const Translation = getLang(langComponent.profile);
  const { uploadBanner, getUser } = useUsers();
  const { uploadBanner: uploadCompanyBanner } = useCompanies();
  const [toggleModal, setToggleModal] = useState(false);
  const [currentTab, setCurrentTab] = useState(0);
  const [bannerImage, setBannerImage] = useState(
    isCompany ? company?.banner : user?.banner
  );
  const [uploadState, setUploadState] = useState(PAGE_STATE.LOADING);

  useEffect(() => {
    if (isCompany && !company) return;
    if (!isCompany && !user) return;

    if (!isCompany) {
      setBannerImage(user.banner);
    }

    if (isCompany) {
      setBannerImage(company.banner);
    }

    setUploadState(PAGE_STATE.IDLE);
  }, [user, company, isCompany]);

  const tabs = isCompany
    ? [
        {
          id: 0,
          value: "General",
        },
        {
          id: 1,
          value: "Payment & Bank Account",
        },
      ]
    : [
        {
          id: 0,
          value: "General",
        },
        {
          id: 1,
          value: "Password",
        },
        {
          id: 2,
          value: "Payment & Bank Account",
        },
      ];

  const getContentToRender = () => {
    if (!isCompany && currentTab === 0) {
      return <EditProfile />;
    }

    if (!isCompany && currentTab === 1) {
      return <Password />;
    }

    if (currentTab === 2) {
      return <Payment />;
    }

    if (isCompany && currentTab === 0) {
      return <EditCompany />;
    }

    if (isCompany && currentTab === 1) {
      return <Payment />;
    }
  };

  const handleViewClose = () => {
    setToggleModal(false);
  };

  const handleSwitchTab = (tabId) => {
    setCurrentTab(tabId);
  };

  const handleBannerFileChanged = async (files) => {
    setUploadState(PAGE_STATE.LOADING);
    setToggleModal(false);

    if (!files || files === undefined) return;

    try {
      if (isCompany) {
        const result = await uploadCompanyBanner(company._id, files);
        setBannerImage(result.banner);
      }

      if (!isCompany) {
        await uploadBanner(user._id, files);

        const _user = await getUser(user._id);

        setBannerImage(_user.banner);
      }

      toast.success("Banner changed!");
    } catch (error) {
      toast.error("Unable to change banner!", {});
    } finally {
      setUploadState(PAGE_STATE.IDLE);
    }
  };

  return (
    <div className="profile-edit">
      {uploadState === PAGE_STATE.LOADING ? (
        <div className="profile-edit-banner__image">
          <ContentLoader width={"100%"} height={"100%"}>
            <rect x="0" y="0" rx="0" ry="0" width="100%" height="100%" />
          </ContentLoader>
        </div>
      ) : (
        <img
          className="profile-edit-banner__image"
          src={`${assetsUri}/${bannerImage}`}
          onError={({ target }) => {
            target.src = backgroundImage;
          }}
        />
      )}
      <div className="profile-edit-banner">
        <div className="profile-edit-banner__upload">
          <Button
            id="banner"
            label={Translation("Upload banner")}
            onClick={() => setToggleModal(true)}
          />
        </div>
      </div>
      <div className="profile-edit-tabs">
        {tabs.map(({ id, value }) => (
          <div
            className={`profile-edit-tabs__tab${
              id === currentTab ? " profile-edit-tabs__tab--active" : ""
            }`}
            key={`profile-edit-tab-${id}`}
            onClick={() => handleSwitchTab(id)}
          >
            {Translation(value)}
          </div>
        ))}
      </div>
      {getContentToRender()}
      {toggleModal && (
        <UploadModal
          onClose={handleViewClose}
          onSuccess={handleBannerFileChanged}
          aspectRatio={4.5}
          type="banner"
        />
      )}
    </div>
  );
};

Edit.propTypes = {};

export default Edit;
